/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useState } from 'react'
import {
  getStudentsRequest,
  getChildrenRequest,
} from 'src/services/api.service'
import { useAuth } from 'src/contexts/auth.context'
import { useNotification } from 'src/contexts/notification.context'
import { GradeSelect, SubjectSelect } from 'src/components/common'
import { Select } from 'src/components/select'
import Search from 'src/components/search'
import Table from 'src/components/table/table'
import { isClass } from 'src/tools'
import StudentRow from './components/student-row'
// import InviteModal from './modals/invite'

export const TeacherStudents = () => {
  const { user } = useAuth()
  const { showErrorHelper } = useNotification()

  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  // const [count, setCount] = useState(0)
  const [pageCount, setPageCount] = useState(0)
  const [filter, setFilter] = useState({
    subject_id: null,
    grade_id: null,
    status: null,
    query: '',
  })
  const [isShowStudentsModal, setIsShowStudentsModal] = useState(false)
  // const [selClassroom, setSelClassroom] = useState(null)

  const fetchData = useCallback(async ({ pageSize, pageIndex, filterData }) => {
    try {
      setLoading(true)

      const getList =
        user.role_id === 1 ? getStudentsRequest : getChildrenRequest

      const response = await getList({
        ...filterData,
        page: pageIndex + 1,
        perPage: pageSize,
      })
      setItems(response.data.items)
      // setCount(response.data.total)
      setPageCount(Math.ceil(response.data.total / pageSize))
    } catch (error) {
      showErrorHelper(error)
    }
    setLoading(false)
  }, [])

  const handleInviteClick = () => () => {
    // setSelClassroom(item)
    setIsShowStudentsModal(true)
  }

  // const handleCloseStudentsModal = () => {
  //   setIsShowStudentsModal(false);
  // }

  // const handleSubmitInviteStudent = async (values) => {
  //   try {
  //     await sendInviteRequest(values)
  //     setIsShowStudentsModal(false);
  //   } catch (error) {
  //     showErrorHelper(error);
  //   }
  // }

  const handleAddStudent = (e) => {
    e.preventDefault()
  }

  return (
    <>
      <h2 className="sectionHb-title">All Students</h2>

      <div className="sectionHb-block purchaseHb">
        <div className="sectionHb-block__wrap">
          <div className="row">
            <div className="col-lg-9 col-md-6 col-sm-6">
              <div className="searchHb searchHb-middle">
                <div className="input-block ">
                  <Search
                    onChange={(value) => {
                      setFilter({ query: value })
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="input-block">
                <a
                  onClick={handleAddStudent}
                  className="primary-btn primary-btn__big"
                >
                  <i className="hb-ico plus-ico-white" />
                  Student
                </a>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="input-block">
                <SubjectSelect
                  value={filter.subject_id}
                  onChange={(item) => {
                    setFilter({ ...filter, subject_id: item?.value })
                  }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="input-block">
                <GradeSelect
                  value={filter.grade_id}
                  onChange={(item) => {
                    setFilter({ ...filter, grade_id: item?.value })
                  }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="input-block">
                <Select
                  placeholder="Status"
                  value={filter.status}
                  onChange={(item) => {
                    setFilter({ ...filter, status: item?.value })
                  }}
                  options={[
                    { value: 'draft', label: 'Draft' },
                    { value: 'open', label: 'Open' },
                    { value: 'closed', label: 'Closed' },
                    { value: 'archive', label: 'Archive' },
                  ]}
                />
              </div>
            </div>
            {/* <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="input-block">
                <Select
                  black
                  placeholder="Period"
                  // icon="/account/images/dest/icons/timetable--small.svg"
                  value={filter.period}
                  onChange={(item) => {setFilter({...filter, period: item?.value})}}
                  options={[
                    { value: "all", label: 'All' },
                    { value: "day", label: 'This day' },
                    { value: "week", label: 'This week' },
                    { value: "month", label: 'This month' },
                  ]}
                />
              </div>
            </div> */}
          </div>

          <div className="details-table details-table__second">
            <div className="details-table__row details-table__top">
              <div className="details-table__col details-table__col-1" />
              <div className="details-table__col details-table__col-2">
                Student name
              </div>
              <div className="details-table__col details-table__col-3">
                Subject
              </div>
              <div className="details-table__col details-table__col-4">
                Classroom
              </div>
            </div>

            <Table
              data={items}
              fetchData={fetchData}
              pageCount={pageCount}
              filter={filter}
              loading={loading}
              rowComponent={(item) => (
                <StudentRow
                  key={item.id}
                  item={item}
                  onInviteClick={handleInviteClick(item)}
                  onStudentClick={handleInviteClick(item)}
                />
              )}
            />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>

      {/* <!-- Modals --> */}
      <div
        className={`mask__modal ${isClass(isShowStudentsModal, 'active')}`}
      />

      {/* <InviteModal
        active={isShowStudentsModal}
        item={selClassroom}
        onClose={handleCloseStudentsModal}
        onSubmit={handleSubmitInviteStudent}
      /> */}
    </>
  )
}
